<template>
  <div class="sn-page sn-assembly pay-result">
    <sn-popup :title="$sn.utils.getFunctionTitle('0', params.func)" :cancel="false" @sendBack="sendBack">
      <div class="sn-f-col-c-c region">
        <div class="sn-f-c-c result-title" :class="{
          'sn-fc-main': title === params.label + '成功',
          'sn-fc-text3': ['网络超时', '查询' + params.label + '结果中...'].includes(title),
          'sn-fc-black': [params.title].includes(title)
        }">{{ title }}</div>
        <div class="sn-f-c-c result-sub" v-if="sub">{{ sub }}</div>
        <div class="sn-f-c-c result-cost">
          本次{{ [perpetual.FUNCTION_ID_MZCZ, perpetual.FUNCTION_ID_ZYCZ].includes(params.func) ? params.label : '支付' }}金额&nbsp;&nbsp;¥{{ params.cost }}
        </div>
        <div class="pattern-blank" :class="{
          'sn-f-c-c': title === params.title
        }">
          <template v-if="title === params.title">
            <div class="sn-f-col-c-c pattern-single" :key="item.itemCode" v-for="item in pattern">
              <img :src="item.qr"/>
              <div class="pattern-title" v-if="pattern.length > 1">{{ item.itemName }}</div>
            </div>
          </template>
          <slot name="result" v-else></slot>
        </div>
        <div class="sn-f-c-c result-interaction">
          <div class="sn-f-c-c sn-pointer interaction sn-bc-background1 sn-fc-text1" @click="sendBack(false);">关闭</div>
          <div class="sn-f-c-c sn-pointer interaction" :class="{'sn-silence': title !== params.label + '成功' && params.interaction.disabled}" v-if="!$sn.validate.empty(params.interaction)"
          @click="() => {
            if (title === params.label + '成功' || !params.interaction.disabled) {
              sendBack(true);
              params.interaction.func();
            }
          }">
            {{ params.interaction.text }}
          </div>
        </div>
      </div>
    </sn-popup>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger.js';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import * as Messages from '@/common/utils/messages';
import * as Tools from '@/common/utils/tools';

export default {
  name: 'pay-result',
  mixins: [HomepageMixin],
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      title: '',
      sub: '',
      pattern: [],
      interval: null
    };
  },
  created: async function() {
    this.title = this.params.title;
    this.sub = this.params.sub;
    this.$sn.assembly.loading(true);
    const dict = await Tools.dict([this.perpetual.DICTIONARY_CODE_REG_TYPE]);
    this.$sn.assembly.loading(false);
    if (!this.$sn.validate.empty(this.params.pay)) {
      Object.keys(this.params.pay).forEach(reg => {
        const match = dict.find(item => item.itemCode === reg);
        if (!this.$sn.validate.empty(match)) {
          this.pattern.push({
            ...match,
            ...this.params.pay[reg]
          });
        }
      });
    }
    this.verifyPayResult();
  },
  methods: {
    verifyPayResult() {
      const search = (no) => {
        return new Promise(resolve => {
          this.$sn.utils.ordinaryRequest({
            url: Swagger.verifyRechargeResult,
            query: {
              no: no
            }
          }).then(result => {
            const fructify = {
              code: 0,
              title: '',
              msg: ''
            };
            if (result) {
              if (result.code === 0) {
                fructify.code = 0;
                if (!this.$sn.validate.empty(result.data)) {
                  if (this.$sn.validate.json(result.data)) {
                    result.data = JSON.parse(result.data);
                  }
                  this.$set(fructify, 'data', result.data);
                }
              }
              else if (result.code === 14 || result.code === '14') {
                fructify.code = 14;
                fructify.title = '网络超时';
                fructify.msg = '由于网络原因导致' + this.params.label + '失败，款项将在1-3个工作日内原路退回到您的账户。';
              }
              else if (result.code === -1 || result.code === '-1') {
                fructify.code = -1;
              }
              else {
                fructify.code = 1;
                fructify.title = this.params.label + '失败';
                fructify.msg = '';
              }
            }
            else {
              fructify.code = -1;
            }
            resolve(fructify);
          });
        });
      };
      let count = 0;
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.interval = setInterval(async() => {
        count++;
        if (count <= 12) {
          const request = {};
          this.pattern.forEach((el, i) => {
            this.$set(request, 'p' + i.toString(), Promise.resolve(''));
            this.$sn.format.setQuality(request, 'p' + i.toString(), search(el.serial));
          });
          Promise.all(Object.values(request)).then(result => {
            if (!this.$sn.validate.empty(result.find(res => res.code === 0))) {
              if (this.interval) {
                clearInterval(this.interval);
              }
              if (this.$sn.validate.empty(this.params.swagger)) this.title = this.params.label + '成功';
              else {
                this.title = '查询' + this.params.label + '结果中...';
                this.$sn.utils.ordinaryRequest(this.params.swagger).then(res => {
                  if (res && res.code === 0) this.title = this.params.label + '成功';
                  else this.title = this.params.label + '失败';
                });
              }
            }
            else if (!this.$sn.validate.empty(result.find(res => res.code !== -1))) {
              if (this.interval) {
                clearInterval(this.interval);
              }
              const res = result.find(res => res.code !== -1);
              this.title = res.title;
              this.sub = res.msg;
            }
            else {
              if (count === 12) {
                if (this.interval) {
                  clearInterval(this.interval);
                }
                this.$sn.assembly.modal({
                  caption: this.$sn.format.caption(Messages.C035, [[this.perpetual.FUNCTION_ID_MZCZ, this.perpetual.FUNCTION_ID_ZYCZ].includes(this.params.func) ? this.params.label : '支付']),
                  captionConfirm: '已完成',
                  captionCancel: '未完成',
                  colorCancel: this.$sn.color.red1,
                  success: (modal) => {
                    if (modal.confirm) {
                      this.title = '查询' + this.params.label + '结果中...';
                    }
                    else if (modal.cancel) {
                      this.title = this.params.title;
                    }
                    this.verifyPayResult();
                  }
                });
              }
            }
          });
        }
        else {
          if (this.interval) {
            clearInterval(this.interval);
          }
          this.$sn.assembly.modal({
            caption: this.$sn.format.caption(Messages.C035, [[this.perpetual.FUNCTION_ID_MZCZ, this.perpetual.FUNCTION_ID_ZYCZ].includes(this.params.func) ? this.params.label : '支付']),
            captionConfirm: '已完成',
            captionCancel: '未完成',
            colorCancel: this.$sn.color.red1,
            success: (modal) => {
              if (modal.confirm) {
                this.title = '查询' + this.params.label + '结果中...';
              }
              else if (modal.cancel) {
                this.title = this.params.title;
              }
              this.verifyPayResult();
            }
          });
        }
      }, 3 * 1000);
    },
    sendBack(type) {
      let status = 0;
      if (this.title === this.params.label + '成功') status = 1;
      this.$emit('sendBack', type, status);
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
};
</script>
<style lang="scss" scoped>
.pay-result {
  z-index: 999;

  ::v-deep .popup {
    width: 700px;
  }

  .region {
    overflow: hidden;
    width: 100%;

    .result-title {
      @include fs(22);

      overflow: hidden;
      width: 100%;
      font-weight: bold;
      color: $red1;
      margin-top: 40px;
    }

    .result-sub {
      @include fs(14);

      overflow: hidden;
      width: 100%;
      color: $text3;
      text-align: center;
      padding: 0 20px;
      margin-top: 10px;
    }

    .result-cost {
      @include fs(18);

      overflow: hidden;
      width: 100%;
      font-weight: bold;
      color: $red1;
      margin-top: 10px;
    }

    .pattern-blank {
      overflow: hidden;
      width: 100%;
      height: 240px;
      padding: 0 20px;
      margin-top: 10px;

      .pattern-single {
        overflow: hidden;
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }

        img {
          width: 200px;
          height: 200px;
        }

        .pattern-title {
          @include fs(16);

          height: 40px;
          font-weight: bold;
          color: $text1;
          margin-top: 10px;
        }
      }
    }

    .result-interaction {
      overflow: hidden;
      width: 100%;
      margin-top: 10px;
      margin-bottom: 40px;

      .interaction {
        @include fs(14);

        overflow: hidden;
        width: 200px;
        height: 40px;
        background-color: $main3;
        color: $white;
        border-radius: 5px;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.result-slot {
  overflow-x: hidden;
  overflow-y: auto;
  width: 80%;
  height: 100%;
  border: 1px solid $border1;
  border-radius: 8px;
  padding: 20px 70px;
  margin: 0 auto;

  .result-line {
    @include fs(16);

    overflow: hidden;
    width: 100%;
    color: $main;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
